<template>
  <div
    ref="popup"
    data-popup
    class="app-dialer-keypad-popup"
    :style="componentStyle"
  >
    <app-dialer-keypad
      :dial="dial"
      :is-disabled="isDisabled"
      @key-click="onKeyClick"
    />

    <div
      class="actions"
      data-popup
    >
      <div
        class="icon-button"
        @click="$emit('close')"
      >
        <or-icon icon="close" />
      </div>

      <div
        class="icon-button"
        @click="onBackspaceClick"
      >
        <or-icon icon="backspace" />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue-demi';
import { OrIconV3 as OrIcon } from '@onereach/ui-components-25';

import { AppDialerKeypad } from '../common';
import { useComponentReposition } from '@/composables/use-component-reposition';

export default defineComponent({
  name: 'AppDialerKeypadPopup',
  components: {
    AppDialerKeypad,
    OrIcon,
  },
  props: {
    isDisabled: Boolean,
  },
  emits: ['key-click', 'close'],
  setup() {
    const { applyReposition, componentStyle } = useComponentReposition();
    return { applyReposition, componentStyle };
  },
  data() {
    return {
      dial: '',
    };
  },
  mounted() {
    this.applyReposition({
      component: this.$refs.popup as HTMLDivElement,
      container: this.getContainingBlock(),
      isMoveEventAvailable: (e: MouseEvent) => {
        return (e.target as HTMLDivElement).hasAttribute('data-popup');
      },
    });
  },
  methods: {
    onKeyClick(key: string) {
      this.dial = this.dial + key;
      this.$emit('key-click', key);
    },

    onBackspaceClick() {
      if (!this.isDisabled && this.dial.length) {
        this.dial = this.dial.slice(0, -1);
      }
    },

    getContainingBlock() {
      return document.querySelector('.agent-ui-desktop') as HTMLElement;
    },
  },
});
</script>

<style lang="scss" scoped>
@import '../../styles';

.app-dialer-keypad-popup {
  @include app-dialer-popup;

  display: inline-flex;
  flex-direction: column;
  padding: 1.5rem;
  cursor: grab;

  .app-dialer-keypad {
    cursor: auto;
  }

  .actions {
    display: flex;
    justify-content: space-between;
    margin-top: 1rem;
    padding: 0 0.25rem;

    .icon-button {
      @include app-dialer-icon-button;
    }
  }
}
</style>
